import React, { useEffect, useState } from 'react';
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { CommonButton, ErrorBlock, SingleSlectSearch } from '../../../Components/CommonComponents';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import { changeManager, getManager } from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import './index.css'
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { handleErrorMessage } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const ChangeManager = () => {

  const navigate = useNavigate();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  useEffect(() => {
    if (!localPermission.includes(Permissions.ADMIN_CHANGE_MANAGER)) {
      navigate('/');
    }
  }, [...localPermission])

  const [isLoading, setIsloading] = useState(false);
  const [userRole, setUserRole] = useState('');

  const [errorMsg, setErrorMsg] = useState({ oldManagerError: '', newManagerErr: '' });
  const [allManager, setAllManager] = useState([]);
  const [oldManagerList, setOldManagerList] = useState([]);
  const [newManagerList, setNewManagerList] = useState([])

  const [oldManagerVal, setOldManagerVal] = useState(null)
  const [newManagerVal, setNewManagerVal] = useState(null)

  useEffect(() => {
    setIsloading(true);
    getManagerList();
  }, [])

  const getManagerList = () => {
    getManager((res) => {
      const { data, success, error } = res;
      if (success) {
        if (data && data.length > 0) {
          // add label key in array
          setAllManager(data);
        } else {
          setAllManager([]);
        }
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    });
  }

  const getFilterManagerRolewise = (val, managerHeading, allManager) => {
    let roleManagerList = allManager.filter(e => e.role === val);
    let roleWiseManagerList = roleManagerList && roleManagerList.length > 0 && roleManagerList[0].OldNewManager && roleManagerList[0].OldNewManager.length > 0 ? roleManagerList[0].OldNewManager : [];

    // add new key label value in array
    let newManagerList = roleWiseManagerList && roleWiseManagerList.length > 0 ? roleWiseManagerList.map(e => ({ ...e, value: e.id, label: `${e.first_name || ''} ${e.last_name || ''}` })) : [];

    let newManagerArr = [{ label: managerHeading, options: newManagerList }]

    setOldManagerList(newManagerArr);
    setNewManagerList(newManagerArr);
  }

  const handleUserTypeChange = (e) => {
    let val = e.target.value;
    setUserRole(val);
    setNewManagerVal('');
    setOldManagerVal('');
    if (val && allManager && allManager.length > 0) {
      if (val === Roles.NH_NAME) {
        getFilterManagerRolewise(val, 'National Head', allManager)
      } else if (val === Roles.SH_NAME) {
        getFilterManagerRolewise(val, 'State Head', allManager)
      } else if (val === Roles.TM_NAME) {
        getFilterManagerRolewise(val, 'Territory Manager', allManager)
      }
    }
  }

  const handleChangeOldManager = (e) => {
    // let val = e && e.value ? e.value : '';
    let val = e && e.value ? e : null;
    setOldManagerVal(val);

    let newManager = newManagerList[0].options.map(elem => ({ ...elem, isDisabled: e && e.value && elem.value === e.value ? true : false }))
    setNewManagerList([{ ...newManagerList, options: newManager }])

    if (!val) { setNewManagerVal('') }
    setErrorMsg({ ...errorMsg, oldManagerError: '' });
  }

  const handleChangeNewManager = (e) => {
    let val = e && e.value ? e : null;
    setNewManagerVal(val);
    setErrorMsg({ ...errorMsg, newManagerErr: '' });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!oldManagerVal) {
      setErrorMsg({ ...errorMsg, oldManagerError: 'Please select Old Manager' });
    }
    if ((!newManagerVal) && oldManagerVal) {
      setErrorMsg({ ...errorMsg, newManagerErr: 'Please select New Manager' });
    }
    if (oldManagerVal && newManagerVal) {
      setErrorMsg({});

      swal({
        title: 'Change Manager',
        text: 'Are you sure want to update manager?',
        icon: 'warning',
        buttons: ['No', 'Yes'],
      }).then((isConfirm) => {
        if (isConfirm) {
          let payload = {
            role: userRole,
            old_manager_id: oldManagerVal.value,
            new_manager_id: newManagerVal.value,
          };
          setIsloading(true);
          changeManager((res) => {
            const { success, message, error } = res;
            if (success === true) {
              ModalService.openAlert('', message, 'success');
              setIsloading(false);
              setOldManagerVal('');
              setNewManagerVal('');
              setUserRole('');
            } else if (success === false || success === 'undefined') {
              ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
              setIsloading(false);
            }
            setIsloading(false);
          }, payload);
        } else {
          setIsloading(false)
        }
      });
    }
  }

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='changeManager'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Change Manager' className="lightTitle" />
                      </div>
                    </Col>
                  </Row>
                  <div className='mainArea'>
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col xs={12}>
                          <div className='statusWrapper'>
                            <FormGroup>
                              <Label className='statusLabel'>Select User Type <span className='required'>*</span></Label>
                              <div className='d-flex'>
                                <FormGroup className='d-flex align-items-center radioGroup mr-3 mb-0'>
                                  <Input
                                    type='radio'
                                    name='userType'
                                    checked={userRole === Roles.NH_NAME}
                                    value={Roles.NH_NAME}
                                    onChange={handleUserTypeChange}
                                    className="m-0"
                                    required
                                  />
                                  <Label className='ml-4 mb-0'>NH</Label>
                                </FormGroup>
                                <FormGroup className='d-flex align-items-center radioGroup mr-3 mb-0'>
                                  <Input
                                    type='radio'
                                    name='userType'
                                    checked={userRole === Roles.SH_NAME}
                                    onChange={handleUserTypeChange}
                                    value={Roles.SH_NAME}
                                    className="m-0"
                                  />
                                  <Label className='ml-4 mb-0'>SH</Label>
                                </FormGroup>
                                <FormGroup className='d-flex align-items-center radioGroup mb-0'>
                                  <Input
                                    type='radio'
                                    name='userType'
                                    checked={userRole === Roles.TM_NAME}
                                    value={Roles.TM_NAME}
                                    onChange={handleUserTypeChange}
                                    className="m-0"
                                  />
                                  <Label className='ml-4 mb-0'>TM</Label>
                                </FormGroup>
                              </div>
                            </FormGroup>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <div className='selectWrapper d-flex flex-wrap'>
                            <div className='selectBlock'>
                              <FormGroup>
                                <Label for='territory'>Select Old Manager: <span className='required'>*</span></Label>
                                <SingleSlectSearch
                                  className='singleSelectOpt'
                                  classNamePrefix='select'
                                  name='oldManager'
                                  placeholder="All"
                                  options={oldManagerList}
                                  isSearchable={true}
                                  isClearable={true}
                                  isDisabled={userRole ? false : true}
                                  value={oldManagerVal === null || oldManagerVal === 'undefined' ? null : oldManagerVal}
                                  onChange={(e) => handleChangeOldManager(e)}
                                // styles={customStyles}
                                />
                              </FormGroup>
                              {errorMsg.oldManagerError ? (
                                <ErrorBlock title={errorMsg.oldManagerError} />
                              ) : (
                                ''
                              )}
                            </div>
                            <div className='selectBlock'>
                              <FormGroup>
                                <Label for='territory'>Select New Manager: <span className='required'>*</span></Label>
                                <SingleSlectSearch
                                  className='singleSelectOpt'
                                  classNamePrefix='select'
                                  name='newManager'
                                  placeholder="All"
                                  options={newManagerList}
                                  isSearchable={true}
                                  isClearable={true}
                                  isDisabled={(userRole && oldManagerVal) ? false : true}
                                  value={newManagerVal === null || newManagerVal === 'undefined' ? null : newManagerVal}
                                  onChange={(e) => handleChangeNewManager(e)}
                                  isOptionDisabled={(option) => option.isDisabled}
                                // styles={customStyles}
                                />
                              </FormGroup>
                              {errorMsg.newManagerErr ? (
                                <ErrorBlock title={errorMsg.newManagerErr} />
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <div className='text-center'>
                            <CommonButton
                              name={'Submit'}
                              btnClass={'btnPrimary'}
                              type='submit'
                              maxWidth='180px'
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default ChangeManager;
